module.exports = __webpack_public_path__ + "static/img/example.5e027f53.jpg";